export default "__VITE_ASSET__CG$WfWOt__"